import dayjs from 'dayjs'

export const formatUserAuditTimestamp = (timestamp) => {
  if (!timestamp) return '-'
  return dayjs(timestamp).format('M/DD/YY HH:mm') + ' hrs'
}

export const formatUserEventType = (eventType, action) => {
  if (action) {
    const actionMap = {
      ADDED: 'Added',
      REMOVED: 'Removed',
      CREATED: 'Created',
      UPDATED: 'Updated',
      DELETED: 'Deleted',
      UPDATE: 'Updated',
      PERMISSION_UPDATE: 'Permission Updated'
    }
    return actionMap[action.toUpperCase()] || action
  }
  if (!eventType) return '-'
  const eventMap = {
    UPDATE: 'Updated',
    CREATE: 'Created',
    DELETE: 'Deleted',
    ADD: 'Added',
    REMOVE: 'Removed'
  }
  return eventMap[eventType.toUpperCase()] || eventType
}

export const formatAccessPeriod = (startDate, endDate, isTemporary) => {
  if (!startDate) return '-'

  const formattedStart = dayjs(startDate).format('M/DD/YY')

  if (!isTemporary || isTemporary === 'N' || isTemporary === false || isTemporary === 0) {
    return `${formattedStart} - Indefinite`
  }

  if (!endDate) {
    return `${formattedStart} - Indefinite`
  }

  const formattedEnd = dayjs(endDate).format('M/DD/YY')
  return `${formattedStart} - ${formattedEnd}`
}

export const formatUserType = (isTemporary) => {
  if (isTemporary === 'Y' || isTemporary === true || isTemporary === 1) {
    return 'Temporary'
  }
  return 'Permanent'
}

export const formatUserStatus = (isActive) => {
  if (isActive === 'Y' || isActive === true || isActive === 1) {
    return 'Active'
  }
  return 'Inactive'
}

export const formatPermissions = (permission) => {
  if (permission === true || permission === 'true' || permission === 1 || permission === '1') {
    return 'View Permission'
  }
  return 'N/A'
}

export const isPermissionEnabled = (permission) => {
  return permission === true || permission === 'true' || permission === 1 || permission === '1'
}

export const formatUserRole = (userRole, userRoleUA) => {
  const role = userRoleUA || userRole
  if (!role) return '-'
  if (Array.isArray(role)) {
    return role.join(', ')
  }
  return role
}

export const USER_AUDIT_COLUMNS = [
  {id: 'userGroup', label: 'User Role', minWidth: 100},
  {id: 'event', label: 'Event', minWidth: 80},
  {id: 'username', label: 'Username', minWidth: 100},
  {id: 'userEmail', label: 'User Email', minWidth: 220},
  {id: 'clientId', label: 'Client ID', minWidth: 80},
  {
    id: 'clientName',
    label: 'Client Name',
    minWidth: 100,
    truncatedContentInfo: 'Hover over the short names to view full content'
  },
  {id: 'projectId', label: 'Project ID', minWidth: 80},
  {
    id: 'projectName',
    label: 'Project Name',
    minWidth: 120,
    truncatedContentInfo: 'Hover over the short names to view full content'
  },
  {id: 'type', label: 'Type', minWidth: 90},
  {id: 'status', label: 'Status', minWidth: 70},
  {id: 'accessPeriod', label: 'Access Period', minWidth: 150},
  {id: 'permissions', label: 'Permissions', minWidth: 120},
  {id: 'timestamp', label: 'Timestamp', minWidth: 150},
  {id: 'modifierEmail', label: 'Modifier Email', minWidth: 220},
  {id: 'modifierRole', label: 'Modifier Role', minWidth: 140}
]

export const transformUserAuditToRow = (user, index) => {
  const formattedTimestamp = formatUserAuditTimestamp(
    user.ACTION_TIME || user.LAST_UPDATED || user.LAST_UPDATED_DATE_TIME
  )
  const projectIdValue = user.PROJECT_ID || user.GROUP_ID_UA || '-'
  const clientIdValue = user.CLIENT_ID || '-'
  const hasPermission = isPermissionEnabled(user.PERMISSION)

  return {
    id: index + 1,
    userGroup: user.USER_GROUP || user.GROUP_TYPE || '-',
    event: formatUserEventType(user.EVENT_TYPE, user.ACTION),
    username: user.USERNAME || '-',
    userEmail: user.USER_EMAIL || user.EMAIL || '-',
    clientId: clientIdValue,
    clientName: user.CLIENT_NAME || '-',
    projectId: projectIdValue,
    projectName: user.GROUP_NAME || '-',
    type: formatUserType(user.IS_TEMPORARY),
    status: user.STATUS || '-',
    accessPeriod: formatAccessPeriod(user.START_DATE, user.END_DATE, user.IS_TEMPORARY),
    permissions: formatPermissions(user.PERMISSION),
    timestamp: formattedTimestamp,
    modifierEmail: user.CHANGED_BY || '-',
    modifierRole: formatUserRole(user.USER_ROLE, user.USER_ROLE_UA),
    changedData: hasPermission ? user.CHANGED_DATA || [] : [],
    snapshot: user.SNAPSHOT || null
  }
}

export const transformUserAuditDataToTableFormat = (auditData) => {
  if (!auditData?.getAuditDetails?.users) {
    return {
      columns: USER_AUDIT_COLUMNS,
      rows: [],
      pagination: {page: 1, pageSize: 5, totalCount: 0}
    }
  }

  const {users, page, pageSize, totalCount} = auditData.getAuditDetails
  const rows = users.map((user, index) => transformUserAuditToRow(user, index))

  return {
    columns: USER_AUDIT_COLUMNS,
    rows,
    pagination: {page, pageSize, totalCount}
  }
}

export default transformUserAuditDataToTableFormat
